import { Icon, IconsEnum } from 'components/Icons';
import { Dispatch, SetStateAction } from 'react';
import styles from './IppicaScommesseTableMoreInfoButton.module.scss';

export type IppicaScommesseTableMoreInfoButtonProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  containerClassName?: string;
};

export const IppicaScommesseTableMoreInfoButton = ({
  isOpen,
  setIsOpen,
  containerClassName,
}: IppicaScommesseTableMoreInfoButtonProps) => {
  return (
    <button
      type="button"
      className={`${styles.button} ${containerClassName ? containerClassName : ''} ${
        isOpen ? styles.backgroundSelected : ''
      }`}
      onClick={() => setIsOpen(!isOpen)}
    >
      <Icon
        iconId={isOpen ? IconsEnum.MINUS_CIRCLE : IconsEnum.PLUS_CIRCLE}
        className={styles.icon}
        color={isOpen ? 'var(--color-on-bg-primary)' : 'var(--color-on-bg-secondary'}
      />
    </button>
  );
};
